


export const PublishSection = () => (
  <div className="space-y-3">
    <h3 className="text-xs font-semibold uppercase text-muted-foreground">Publishing</h3>
    <div className="text-sm">Status: <span className="font-medium text-foreground">Draft</span></div>
  </div>
);
